const BUTTON_MIN_WIDTH_MAP = {
  lg: "240px",
  md: "208px",
  sm: "148px"
};
function getButtonMinWidth({
  fixedWidth,
  size,
  component
}) {
  if (fixedWidth && component === "Button" && size) {
    return BUTTON_MIN_WIDTH_MAP[size];
  }
}
export {
  BUTTON_MIN_WIDTH_MAP,
  getButtonMinWidth
};
